export default class ReservationImage {
  constructor() {
    this.name = "";
    this.content = "";
  }
}
